/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import Loader from 'react-loader-spinner';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { useApiRequestState } from '../../../utils/api.utils';
import { useSelectWithParams } from '../../../utils/selector.utils';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { PasswordFrom } from '../../pages/PasswordsPage/PasswordForm';

import { ConnectedDialog } from '../ConnectedDialog';
import { IPasswordFormDialogProps } from './types';

export const PasswordFormDialog: FunctionComponent = () => {
  const dispatch = useDispatch();
  const props = useSelectWithParams(
    dialogSelectors.selectDialogProps,
    'passwordFormDialog',
  ) as IPasswordFormDialogProps;

  const [showLoader, error] = useApiRequestState('savePassword');

  const onClose = useCallback(() => {
    dispatch(closeDialog('passwordFormDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="passwordFormDialog">
      <div className="popup new_team_popup mid-popup isVisible">
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            <h3>{props?.data ? 'Edit Password' : 'Add New Password'} </h3>
            <span className="close-popup close">
              {showLoader && <Loader type="TailSpin" color="var(--theme-primary-color)" height={20} width={20} />}
              {error && <p style={{ color: 'red' }}> Something went wrong </p>}
            </span>
          </div>
          <div className="panel-body pt-0" style={{ maxHeight: '500px' }}>
            <PasswordFrom {...props} />
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" title="" onClick={onClose}>
              Close
            </a>
            <SubmitButton apiKey="savePassword" formName="password-form" text="Save" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
